export default __webpack_public_path__ + "media/images/testimonials-0b5258defe0dd660d8a40048eebe36ab.jpg";